import React, { createContext, useContext, useMemo } from 'react';

const Context = createContext();

export const DeskEntityProvider = ({ deskIndex, entityKey, children }) => {
  const value = useMemo(() => [deskIndex, entityKey], [deskIndex, entityKey]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useDeskEntity = () => useContext(Context);
